import { render, staticRenderFns } from "./NafPanel.vue?vue&type=template&id=64b27116&"
import script from "./NafPanel.vue?vue&type=script&lang=js&"
export * from "./NafPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports